import { http, HttpResponse } from 'msw';

import { SignApplicationResponse } from '../../api/signApplication';
import { MockServiceWorker } from '../mockServiceWorker';
import { getNextState } from './patchApplicationHandlers';

export const signingLinkHandler = [
    http.post('*/api/cl_loanapp_proxy_service/v1/:countryCode/application/:arn/signing_link?isDesktop=true', async () => {
        const response: SignApplicationResponse = {
            signLink: '',
        };

        const session = MockServiceWorker.getMockedSession();
        session.state = getNextState('SIGN_AGREEMENT');
        MockServiceWorker.setMockedSession(session);

        return HttpResponse.json(response);
    }),
];
